import { render, staticRenderFns } from "./BookingCustomerDetailscustomerTable.vue?vue&type=template&id=9a0943b6&scoped=true&lang=true"
import script from "./BookingCustomerDetailscustomerTable.vue?vue&type=script&lang=js"
export * from "./BookingCustomerDetailscustomerTable.vue?vue&type=script&lang=js"
import style0 from "./BookingCustomerDetailscustomerTable.vue?vue&type=style&index=0&id=9a0943b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0943b6",
  null
  
)

export default component.exports